// Pure helpers for the Analytics page: range presets, KPI tiles and CSV shaping.

export const RANGES = [
  { key: '7d', label: 'Last 7 days', days: 7 },
  { key: '30d', label: 'Last 30 days', days: 30 },
  { key: '90d', label: 'Last 90 days', days: 90 }
];

export function rangeParams(days) {
  const to = new Date();
  const from = new Date(to.getTime() - (days - 1) * 24 * 60 * 60 * 1000);
  return { from: from.toISOString(), to: to.toISOString() };
}

const CALLER_LABELS = {
  tenant: 'Tenants',
  prospect: 'Prospects',
  owner: 'Owners',
  vendor: 'Vendors',
  other: 'Other',
  unknown: 'Unlabeled'
};

export function callerLabel(role) {
  return CALLER_LABELS[role] || (role ? role[0].toUpperCase() + role.slice(1) : 'Unlabeled');
}

export function byCaller(rows = []) {
  const totals = new Map();
  rows.forEach((r) => {
    const label = callerLabel(r.role);
    totals.set(label, (totals.get(label) || 0) + (r.calls || 0));
  });
  return [...totals].map(([label, calls]) => ({ label, calls }));
}

// The six KPI tiles, in design order. Hides nothing — zeros still read as data.
export function kpiTiles(kpis = {}) {
  return [
    { label: 'Calls answered', value: kpis.callsAnswered ?? 0 },
    { label: 'After hours', value: `${kpis.afterHoursPct ?? 0}%`, sub: `${kpis.afterHours ?? 0} calls` },
    { label: 'Tour requests', value: kpis.tourRequests ?? 0 },
    { label: 'Work orders', value: kpis.workOrders ?? 0, sub: 'Last 4 weeks' },
    {
      label: 'Emergencies',
      value: kpis.emergencies ?? 0,
      sub: kpis.medianAcceptMin ? `Median accept ${kpis.medianAcceptMin} min` : undefined
    },
    { label: 'Office time handled', value: `${kpis.officeTimeHours ?? 0} h`, sub: 'Estimate' }
  ];
}

export function toPercents(rows = [], valueKey = 'calls') {
  const total = rows.reduce((a, r) => a + (r[valueKey] || 0), 0) || 1;
  return rows.map((r) => ({ ...r, pct: Math.round(((r[valueKey] || 0) / total) * 100) }));
}

export function seriesToCsv(series = []) {
  const rows = [['Date', 'Calls'], ...series.map((s) => [s._id, s.calls])];
  return rows.map((r) => r.join(',')).join('\n');
}
